import api from './api';
import { Subdepartamento, ApiResponse } from '../types';

export const subdepartamentoService = {
  listar: async (): Promise<Subdepartamento[]> => {
    const response = await api.get<Subdepartamento[]>('/subdepartamentos');
    return response.data;
  },

  listarAtivos: async (): Promise<Subdepartamento[]> => {
    const response = await api.get<Subdepartamento[]>('/subdepartamentos/ativos');
    return response.data;
  },

  listarPorDepartamento: async (departamentoId: number): Promise<Subdepartamento[]> => {
    const response = await api.get<Subdepartamento[]>(`/subdepartamentos/departamento/${departamentoId}`);
    return response.data;
  },

  buscarPorId: async (id: number): Promise<Subdepartamento> => {
    const response = await api.get<Subdepartamento>(`/subdepartamentos/${id}`);
    return response.data;
  },

  cadastrar: async (subdepartamento: Subdepartamento): Promise<ApiResponse<Subdepartamento>> => {
    const response = await api.post<ApiResponse<Subdepartamento>>('/subdepartamentos', subdepartamento);
    return response.data;
  },

  atualizar: async (id: number, subdepartamento: Subdepartamento): Promise<ApiResponse<Subdepartamento>> => {
    const response = await api.put<ApiResponse<Subdepartamento>>(`/subdepartamentos/${id}`, subdepartamento);
    return response.data;
  },

  deletar: async (id: number): Promise<ApiResponse<void>> => {
    const response = await api.delete<ApiResponse<void>>(`/subdepartamentos/${id}`);
    return response.data;
  },
};
